/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react'
import { RxCross1 } from 'react-icons/rx'

const Modal = ({ title, children, onClose, contentClassName = '' }) => {

    const handleCloseOnBackdropClick = (e) => {
        if (e.target.id === 'backdrop') {
            onClose();
        }
    }

    return (
        <div
            id="backdrop"
            onClick={handleCloseOnBackdropClick}
            className="fixed inset-0 z-[200000] flex justify-center overflow-y-auto bg-black/50 p-3 sm:p-6"
            role="presentation"
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
                onClick={(e) => e.stopPropagation()}
                className={`my-auto flex w-full max-h-[calc(100dvh-1.5rem)] min-h-0 max-w-lg flex-col rounded-lg bg-white-50 shadow-xl sm:max-w-2xl md:max-w-3xl ${contentClassName}`}
            >
                <div className="flex shrink-0 items-start justify-between gap-3 border-b border-gray-200 bg-white-50 px-4 py-4 sm:px-5">
                    <strong id="modal-title" className="pr-2 text-lg font-semibold leading-snug sm:text-xl">
                        {title}
                    </strong>
                    <button
                        type="button"
                        onClick={onClose}
                        className="shrink-0 rounded-md p-1 text-gray-600 hover:bg-gray-100"
                        aria-label="Close"
                    >
                        <RxCross1 />
                    </button>
                </div>
                <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain bg-white-50 px-4 py-4 sm:px-5">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Modal
